<template>
  <section style="display: flex; flex-direction: column">
    <div class="virtual_guard__profile">
      <div class="virtual_guard__card">
        <div id="screen" class="virtual_guard__card_main_view">

        </div>
        <div class="virtual_guard__card_actions">
          <span @click="hangUp()" style="margin-right: 20px; cursor: pointer; height: 7vh; min-height: 22px;"><hand-out-icon></hand-out-icon></span>
          <span :class="['virtual_guard__counter', {'virtual_guard__counter--red': counter <= 10}]"> {{ counter }} segundos</span>
        </div>
      </div>
    </div>
    <div class="virtual_guard__alert_message" v-if="showCallCancellation">
      
    </div>
  </section>
</template>
<script>

import HandOutIcon from "@/components/shared/icons/HandOutIcon.vue";

export default {
  components: {
    HandOutIcon
  },
  props: {
    current_sublocation: {
      type: String,
      required: true,
    },
    connection_id: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      token: null,
      api: null,
      callTimer: null,
      showCallCancellation: false,
      counter: 60,
    };
  },
  mounted() {
    this.getToken();
  },
  methods: {
    getToken() {
      const vm = this;
      try {
        this.$http.get('digital_guard/generate_jwt', {
          params: {
            sublocation_id: this.current_sublocation,
          },
          headers: {
            "X-Device-ID": this.getDeviceId(),
            Authorization: process.env.VUE_APP_JITSI_TOKEN_AUTHORIZATION,
          }
        }).then(response => {
          vm.token = response.body.data;
          setTimeout(() => {
            vm.launchVideoCall();
          }, 1000);
        })
      } catch (err) {
        console.error(err);

      }
    },
    launchVideoCall() {
      const room = `room_virtual_guard_${this.current_sublocation}`;
      this.$cable.perform({
        channel: 'VirtualGuardChannel',
        action: 'send_message',
        data: {
          room,
          message: 'answerCall',
          answer_call: true,
          sublocation_id: this.current_sublocation,
          connection_id: this.connection_id,
        }
      });
      const domain = process.env.VUE_APP_JITSI_URL;
      const options = {
        roomName: `room_virtual_guard_${this.current_sublocation}`,
        width: "100%",
        height: "100%",
        lang: "es",
        parentNode: document.querySelector("#screen"),
        userInfo: {
          email: "user@fusepong.com",
          displayName: "Usuario",
          role: "user",
        },
        configOverwrite: {
          disableDeepLinking: true,
          enableWelcomePage: false,
          startWithVideoMuted: false,
          startWithAudioMuted: false,
          prejoinPageEnabled: false,
        },
        interfaceConfigOverwrite: {
          TOOLBAR_BUTTONS: [],
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          SHOW_BRAND_WATERMARK: false,
          SHOW_CHROME_EXTENSION_BANNER: false,
          HIDE_INVITE_MORE_HEADER: true,
          MOBILE_APP_PROMO: false,
          HIDE_DEEP_LINKING_LOGO: true,
          filmStripOnly: false,
          SHOW_CONTACTLIST_AVATARS: false,
          DEFAULT_REMOTE_DISPLAY_NAME: '',
          DEFAULT_LOCAL_DISPLAY_NAME: '',
          SHOW_PROMOTIONAL_CLOSE_PAGE: false,
          SHOW_POWERED_BY: false,
          SHOW_PARTICIPANTS_TAB: false,
          SHOW_CHAT_HEADER: false,
          SHOW_FOOTER_ACTIONS: false,
          TOOLBAR_ALWAYS_VISIBLE: false,
          DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
          DISABLE_DOMINANT_SPEAKER_INDICATOR: true,
          DISABLE_FOCUS_INDICATOR: true,
          TILE_VIEW_MAX_COLUMNS: 1,
          DISABLE_RINGING: true,
        },
        jwt: this.token,
      }
      this.api = new window.JitsiMeetExternalAPI(domain, options);
      this.api.addListener('readyToClose', () => {
        const room = `room_virtual_guard_${this.current_sublocation}`;
        this.$cable.perform({
          channel: 'VirtualGuardChannel',
          action: 'send_message',
          data: {
            room,
            message: 'notifyCallEnded',
            notify_call_ended: true,
            sublocation_id: this.current_sublocation,
            connection_id: this.connection_id,
          },
        });
        this.api.dispose();
        this.$emit('hangUp');
      });
      const vm = this;
      document.addEventListener('keydown', this.buttonAction);
      this.api.addEventListener('videoConferenceJoined', () => {
        vm.counter = 60;
        vm.callTimer = setInterval(() => {
          vm.counter--;
          if (vm.counter === 0) {
            clearInterval(vm.callTimer);
            vm.hangUp();
          }
        }, 1000);
      });
    },
    buttonAction(event) {
      if (event.keyCode !== 65) return;
      this.hangUp();

    },
    hangUp() {
      const room = `room_virtual_guard_${this.current_sublocation}`;
      this.$cable.perform({
        channel: 'VirtualGuardChannel',
        action: 'send_message',
        data: {
          room,
          message: 'notifyCallEnded',
          notify_call_ended: true,
          sublocation_id: this.current_sublocation,
          connection_id: this.connection_id,
        },
      });
      this.api.dispose();
      this.$emit('hangUp');
      document.removeEventListener(' keydown', this.buttonAction);
    }
  }
}
</script>